import { Component, computed, input, Input, OnInit, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';

export type LoaderSizeAlias = 'xs' | 'sm' | 'smd' | 'md' | 'lg' | 'xxlg';
export type LoaderSizeValue = 12 | 14 | 16 | 18 | 24 | 48;
export type LoaderOverlayColorAlias = 'light' | 'dark' | 'transparent';


@Component({
  selector: 'lbt-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [
    MatProgressSpinner,
    NgClass
  ]
})
export class LoaderComponent {
  protected readonly sizes: Record<LoaderSizeAlias, LoaderSizeValue> = {
    xs: 12,
    sm: 14,
    smd: 16,
    md: 18,
    lg: 24,
    xxlg: 48,
  };

  protected readonly overlayClass = computed<string | null>(
    () => this.overlayColor() ? ('lgt-loader-overlay-' + this.overlayColor()) : null
  )

  readonly size = input<LoaderSizeAlias>('smd');
  readonly overlayColor = input<LoaderOverlayColorAlias>('light');
  readonly overlayLabel = input<string>();


}
